import FilterListList from 'common/pages/filter-list/FilterListList'

export const FilterListListAdv = (props) =>
    <FilterListList {...props} admin={false} />